var map = {
	"./admin.scss": 1047,
	"./editor.scss": 5642,
	"./mixins/_buttons.scss": 141,
	"./mixins/_inputs.scss": 1909,
	"./mixins/_typography.scss": 1290,
	"./mixins/_vars.scss": 1933,
	"./pages/cart.scss": 3213,
	"./pages/catalog.scss": 2869,
	"./pages/checkout.scss": 2219,
	"./pages/delivery.scss": 811,
	"./pages/error.scss": 1070,
	"./pages/page.scss": 2037,
	"./pages/single-product.scss": 9488,
	"./pages/thankyou.scss": 6345,
	"./static-page.scss": 358,
	"./style.scss": 7160,
	"./ui/breadcrumbs.scss": 3106,
	"./ui/buttons.scss": 8156,
	"./ui/checkbox.scss": 3264,
	"./ui/inputs.scss": 7677,
	"./ui/radio.scss": 2000,
	"./ui/tag.scss": 6562,
	"./ui/text.scss": 7887,
	"./ui/toast.scss": 4391,
	"./utils/main.scss": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7651;